import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'

import light from './../../Resources/AppScreens/CommonComponents/LightBackground.png';
import dark from './../../Resources/AppScreens/CommonComponents/DarkBackground.png';

import HealthcarePreview from './HealthcarePreview';
import HospitalityPreview from './HospitalityPreview';
import AdvocacyPreview from './AdvocacyPreview';
import CampusPreview from './CampusPreview';
import EventsPreview from './EventsPreview';
import OtherPreview from './OtherPreview';
import RetailPreview from './RetailPreview';
import WorkplacePreview from './WorkplacePreview';
const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 290px;
    height: 628px;
    background-image: url(${({theme}) => (theme === 'dark') ? dark : light });
    background-size: 100% 100%;
    overflow: hidden;
     box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 768px) and (max-width: 1025px){
        width: 211px;
        height: 465px;
    }
`;
Container.propTypes = {
    theme: PropTypes.string
}
const components = { 
    preview: 
    {
        "Advocacy" : (features) => (<AdvocacyPreview features={features} />),
        'Healthcare': (features) => (<HealthcarePreview features={features} />),
        'Hospitality': (features) => (<HospitalityPreview features={features} />),
        'Campus': (features) => (<CampusPreview features={features} />),
        "Events": (features) => (<EventsPreview features={features} />),
        "Other": (features) => (<OtherPreview features={features} />),
        "Retail": (features) => (<RetailPreview features={features} />),
        "Workplace": (features) => (<WorkplacePreview features={features} />)
    }
};

export default class DevicePreview extends Component {
    static propTypes = {
        industry: PropTypes.string,
        features: PropTypes.arrayOf(PropTypes.string)
    };

    render(){
        const {industry, features, theme} = this.props;
        return <Container theme={theme}>
            {industry && components.preview[industry] && components.preview[industry](features)}
            
        </Container>
    }
}